import { MenuItem, Tooltip } from '@chakra-ui/react';
import { IconArrowInbox } from 'central-icons/IconArrowInbox';

import { downloadData } from '../Chart/chart-menu/data-download/download-plot-data';
import { useTableSelection } from '../TableSelectionProvider/TableSelectionProvider';
import { buildPostingXlsxRows } from './PostingDiscoverySelectedDataExportMenuItem';

export const PostingDiscoveryDataExportMenuItem = () => {
  const { allRows } = useTableSelection();
  const isDisabled = allRows.length === 0;

  const triggerDownload = () => {
    if (allRows.length === 0) return;
    const fileName = `posting-discovery-export-${new Date().toISOString().slice(0, 10)}`;
    downloadData(buildPostingXlsxRows(allRows), fileName);
  };

  const menuItem = (
    <MenuItem
      icon={<IconArrowInbox size={16} />}
      onClick={triggerDownload}
      isDisabled={isDisabled}
    >
      Download All
    </MenuItem>
  );

  if (!isDisabled) return menuItem;

  return (
    <Tooltip
      label="Apply filters to load postings before downloading"
      hasArrow
      variant="label"
      openDelay={300}
      placement="bottom"
    >
      <span>{menuItem}</span>
    </Tooltip>
  );
};
